
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Weddingcarrentalinpune() {



    const cardData =
    {
        keyword: 'Wedding Car Rental in Pune',
        heading: 'S9 Travels: Wedding Car Rental in Pune',
        headingDescription: 'S9 Travels offers Wedding Car Rental in Pune, providing elegant, luxurious, and well-maintained cars to make your special day even more memorable. Choose from a premium fleet, including luxury sedans, SUVs, and classic vintage cars, to complement your wedding style. Enjoy on-time service, professional chauffeurs, affordable pricing, and 24/7 availability for a seamless experience. Book your Wedding Car Rental in Pune with S9 Travels and arrive in style on your big day!',


        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada was built in 1732 by the Peshwas of the Maratha Empire. Once the seat of the Peshwa rulers, this grand palace is known for its magnificent architecture, massive gateways, and intriguing legends. The evening light and sound show offers a captivating retelling of its history, making it a must-visit for history lovers."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Muhammed Shah Aga Khan III, this stunning palace holds great historical significance. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters during the Indian independence movement. The palace is surrounded by lush gardens and houses a museum displaying artifacts related to Gandhi's life and legacy."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. This fort, which was the site of the historic Battle of Sinhagad in 1670, is a favorite among trekking enthusiasts. Visitors can explore the ruins, pay homage to the brave warrior Tanaji Malusare, and enjoy local delicacies like pithla bhakri at nearby food stalls."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene retreat for spiritual seekers. It offers a variety of meditation programs, wellness sessions, and yoga classes in a peaceful environment. The ashram attracts visitors from across the globe looking to rejuvenate their mind and body through mindfulness and meditation."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, Pataleshwar Cave Temple dates back to the 8th century. Carved out of a single basalt rock, this temple features beautiful stone pillars and a sanctum with a Shiva Lingam. The tranquil atmosphere makes it an ideal spot for those seeking a blend of history, spirituality, and ancient architecture."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This unique museum houses an extensive collection of over 20,000 artifacts, including sculptures, paintings, weapons, musical instruments, and everyday household items from different periods of Indian history. It provides a fascinating insight into the artistic heritage of Maharashtra and India as a whole."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "A scenic getaway just a short drive from Pune, Khadakwasla Dam is a perfect spot for nature lovers and picnickers. The dam, which supplies water to Pune, offers stunning views of the reservoir and nearby hills. The cool breeze and peaceful surroundings make it an excellent location for a leisurely evening outing."
    },
    {
      "title": "Fergusson College Road",
      "description": "Known for its vibrant and youthful energy, Fergusson College Road is a popular hangout spot among students and young travelers. It is lined with cafes, bookstores, street vendors, and shopping outlets. Whether you're looking for trendy fashion, delicious street food, or a lively atmosphere, this street has something for everyone."
    },
    {
      "title": "Lal Mahal",
      "description": "A historically significant landmark, Lal Mahal was originally built in the 1630s by Shahaji Bhosale for his son, Chhatrapati Shivaji Maharaj. Though the original structure was destroyed, the reconstructed Lal Mahal offers a glimpse into the childhood of Shivaji Maharaj and features paintings and artifacts related to his life."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as the Japanese Garden, this beautifully designed landscape park is inspired by the Korakuen Garden in Okayama, Japan. It features manicured lawns, flowing streams, koi ponds, and traditional Japanese-style architecture. It's a perfect place for a peaceful stroll or a relaxing family outing."
    }
],

"services": [
  {
    "name": "Wedding Car Rental in Pune",
    "description": "S9 Travels offers premium wedding car rental services in Pune, providing a fleet of well-maintained and elegant cars for your special day. Whether you're looking for a luxurious ride to the venue or transportation for your guests, we offer a variety of options to suit your wedding needs."
  },
  {
    "name": "Book Wedding Cars in Pune",
    "description": "Book wedding cars in Pune with ease through S9 Travels. We offer a wide range of vehicles to match your wedding theme, from elegant sedans to luxurious limousines, ensuring that you arrive in style on your big day. Our professional chauffeurs ensure a safe and timely journey to your wedding venue."
  },
  {
    "name": "Affordable Wedding Car Rental in Pune",
    "description": "Looking for an affordable wedding car rental in Pune? S9 Travels offers budget-friendly options without compromising on style or comfort. Our fleet includes well-maintained cars that are perfect for wedding events, offering reliable service at competitive prices."
  },
  {
    "name": "Luxury Wedding Cars for Hire in Pune",
    "description": "Travel in style on your wedding day with luxury wedding cars for hire in Pune from S9 Travels. Choose from our range of high-end cars and limousines, designed to make your wedding day even more memorable. Our luxury vehicles come with professional chauffeurs, ensuring an exquisite experience."
  },
  {
    "name": "Pune Wedding Car Hire for Special Occasions",
    "description": "Make your wedding day unforgettable with Pune wedding car hire from S9 Travels. Whether you need a car for the bride, groom, or guests, we offer a variety of options to ensure your special day is truly exceptional. Choose from classic cars, modern vehicles, and luxury options, all with impeccable service."
  },
  {
    "name": "Wedding Transportation in Pune",
    "description": "S9 Travels provides seamless wedding transportation in Pune, offering a range of vehicles for the bride, groom, and guests. From elegant cars to luxury limousines, we ensure you and your loved ones travel in comfort and style on your big day, with timely arrivals and professional chauffeurs."
  },
  {
    "name": "Bridal Car Hire in Pune",
    "description": "For the bride who deserves the best, S9 Travels offers premium bridal car hire in Pune. Our fleet of luxurious cars and vintage options ensure you arrive in style, with comfort and elegance. Let us help make your wedding day as special as you’ve imagined, with a beautiful ride to match."
  },
  {
    "name": "Wedding Convoy Service in Pune",
    "description": "S9 Travels offers wedding convoy services in Pune to ensure all your wedding guests are transported smoothly. Whether it’s for family members or a larger group, our convoy service provides coordinated travel to and from the venue, with a fleet of cars and professional chauffeurs to ensure everyone arrives on time."
  },
  {
    "name": "Pune Wedding Limousine Service",
    "description": "Arrive in style with our Pune wedding limousine service. S9 Travels offers luxurious limousines for your special day, equipped with premium features to ensure maximum comfort and sophistication. Perfect for the bride, groom, or VIP guests, our limousines add a touch of elegance to your wedding."
  }
],

"tableData": [
  ["Wedding Car Rental in Pune", "Book Wedding Cars in Pune"],
  ["Affordable Wedding Car Rental in Pune", "Luxury Wedding Cars for Hire in Pune"],
  ["Pune Wedding Car Hire for Special Occasions", "Wedding Transportation in Pune"],
  ["Bridal Car Hire in Pune", "Wedding Convoy Service in Pune"],
  ["Pune Wedding Limousine Service", ""],
  ["", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Elegant and Luxurious Wedding Cars",
    "WhyChoosedescription": "S9 Travels offers a wide range of luxury wedding cars for rent in Pune, including premium vehicles like the Toyota Innova, BMW, Mercedes, and more. Our fleet ensures you arrive in style, with elegant cars designed to complement your special day."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that punctuality is crucial for your wedding day. Our wedding car rental service in Pune guarantees timely pick-ups and drop-offs, ensuring your journey to and from the wedding venue is seamless and stress-free."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are professional, experienced, and dressed to impress. They are familiar with the best routes in Pune, ensuring a smooth and comfortable ride to your wedding venue, while prioritizing safety and efficiency on your special day."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for wedding car rentals in Pune. We provide clear pricing with no hidden charges, allowing you to easily plan your wedding transportation budget without any surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Wedding Day",
    "WhyChoosedescription": "Your safety and comfort are our top priorities. Our wedding cars are equipped with modern safety features like airbags, GPS tracking, and seat belts, ensuring you have a safe and luxurious experience on your wedding day."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your wedding car rental needs. Whether you need a car for early morning ceremonies or late-night celebrations, we are here to ensure your wedding transportation is perfectly timed."
  },
  {
    "WhyChooseheading": "Customizable Wedding Car Packages",
    "WhyChoosedescription": "We understand that every wedding is unique. Whether you need multiple cars for your guests, require a specific car model, or have special transportation requests, we offer customizable wedding car rental packages to meet your needs."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your wedding car rental with S9 Travels is quick and easy. You can book online through our website or mobile app, or contact our customer service team for personalized assistance, ensuring your booking process is smooth and stress-free."
  }
]















    }

    const faqData = [
        [
          {
            question: 'How can I book a wedding car rental in Pune?',
            answer: 'Booking a wedding car rental in Pune is simple! You can book through our website, mobile app, or by contacting our customer service team for assistance. We ensure a smooth and timely process for your big day.',
          },
          {
            question: 'What types of wedding cars are available for rent in Pune?',
            answer: 'We offer a wide range of luxury wedding cars for rent in Pune, including premium sedans, SUVs, classic cars, and vintage cars. Choose the vehicle that complements your wedding theme and adds elegance to your special day.',
          },
          {
            question: 'Do you provide chauffeurs with the wedding car rental in Pune?',
            answer: 'Yes, we provide experienced and professional chauffeurs with all our wedding car rentals in Pune. Our chauffeurs are well-dressed, courteous, and will ensure that you have a smooth and stylish ride to your wedding venue.',
          },
          {
            question: 'How far in advance should I book a wedding car in Pune?',
            answer: 'We recommend booking your wedding car at least 2-3 weeks in advance to secure availability and ensure you get the car of your choice. However, last-minute bookings may also be accommodated based on availability.',
          },
          {
            question: 'Can I decorate the wedding car for my ceremony?',
            answer: 'Absolutely! You can decorate the wedding car with flowers or other decorations as per your preferences. Our team will also assist you with recommendations for beautiful decorations if needed.',
          },
          {
            question: 'Is there a specific time duration for the wedding car rental in Pune?',
            answer: 'Wedding car rentals in Pune are typically offered on an hourly or full-day basis. We can customize the rental duration based on your needs, whether it’s for a few hours or the entire day for your wedding events.',
          },
          {
            question: 'How much does it cost to rent a wedding car in Pune?',
            answer: 'The cost of renting a wedding car in Pune depends on the type of vehicle, duration of the rental, and any additional services or customization. Contact us for a customized quote based on your specific wedding requirements.',
          },
          {
            question: 'Do you offer multiple wedding cars for large weddings?',
            answer: 'Yes, we can provide multiple wedding cars for large weddings. Whether you need cars for the bride, groom, or family members, we can arrange a fleet to suit your needs and ensure everyone arrives on time.',
          },
          {
            question: 'Can I request a specific car model for my wedding rental?',
            answer: 'Yes, we offer a wide range of luxury and classic cars, and you can request a specific model for your wedding. We recommend booking in advance to secure your preferred vehicle.',
          },
          {
            question: 'Why should I choose S9 Travels for my wedding car rental in Pune?',
            answer: 'S9 Travels offers elegant, well-maintained wedding cars with professional chauffeurs to make your special day even more memorable. With a range of luxury cars, excellent customer service, and attention to detail, we ensure a smooth and stylish wedding experience.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Groom',
          rating: [1, 1, 1, 1, 1],
          text: '“I rented a wedding car from S9 Travels for my big day in Pune, and the experience was fantastic. The car was stunning, and the chauffeur was well-dressed, polite, and on time. The ride was smooth and comfortable, and it added the perfect touch of elegance to my wedding. Highly recommend S9 Travels for wedding car rentals!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Bride',
          rating: [1, 1, 1, 1, 1],
          text: '“We rented a luxury wedding car from S9 Travels for my wedding in Pune, and I couldn’t have asked for a better experience. The car was exactly as we imagined, and the chauffeur was incredibly courteous. It was a wonderful touch to our wedding day, and I would definitely recommend S9 Travels for wedding car rentals in Pune!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Wedding Car Rental in Pune",
        "description": "Book luxury and affordable wedding car rental services in Pune. Whether you're looking for a bridal car, wedding convoy, or limousine service, S9 Travels offers a wide selection of cars for your special day, ensuring comfort and style.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      


    return (
        <div>
        
        <Helmet>
        <title>Wedding Car Rental in Pune | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book wedding car rentals in Pune for your special day. Luxury bridal cars, wedding convoy, and limousine services. Affordable and stylish wedding transportation with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/76.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Weddingcarrentalinpune;